import { render } from "./PatientSelectInput.vue?vue&type=template&id=3bca9d80&scoped=true"
import script from "./PatientSelectInput.vue?vue&type=script&lang=js"
export * from "./PatientSelectInput.vue?vue&type=script&lang=js"

import "./PatientSelectInput.vue?vue&type=style&index=0&id=3bca9d80&scoped=true&lang=css"
import "./PatientSelectInput.vue?vue&type=style&index=1&id=3bca9d80&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bca9d80"]])

export default __exports__